import * as Sentry from '@sentry/browser';
import { createBrowserHistory as createHistory } from 'history';
import { LocationState } from '../types';

export const history = createHistory<LocationState>();

history.listen((location, action) => {
  Sentry.addBreadcrumb({
    category: 'navigation',
    type: 'navigation',
    level: 'info',
    message: `${action} ${location.pathname}${location.search ?? ''}`,
    data: {
      pathname: location.pathname,
      search: location.search,
      action
    }
  });
});
